/**
 * Foundation/Core — Informazioni di sistema (logica pura, riusabile da ogni modulo Suite).
 * Trasforma la risposta di `GET /api/system/runtime` + il contesto del browser
 * in righe etichetta/valore e nel testo "Copia informazioni tecniche".
 */

const SERVED_BY = {
  integrated: "Build integrata",
  suite: "GI Suite Shell",
  external: "Frontend esterno",
};

export function getClientContext() {
  return {
    devServer: process.env.NODE_ENV === "development",
    port: typeof window !== "undefined" ? window.location.port : "",
  };
}

export function describeFrontendSource(runtime, client) {
  if (client.devServer) return `React Dev Server${client.port ? ` (${client.port})` : ""}`;
  return SERVED_BY[runtime?.frontend_mode?.effective] || "—";
}

function describeBuild(build) {
  if (!build) return { kind: "Non compilata (sviluppo)", commit: "—" };
  if (build.source === "zip") return { kind: "ZIP", commit: "unknown (ZIP)" };
  return { kind: "Git", commit: `${build.commit_short} (${build.branch})` };
}

export function buildSystemInfoRows(runtime, client) {
  const build = runtime.build;
  const b = describeBuild(build);
  const mode = (runtime.frontend_mode?.configured || runtime.frontend_mode?.effective || "").toUpperCase();
  const db = runtime.database || {};
  return [
    { id: "product", label: "Prodotto", value: runtime.product },
    { id: "version", label: "Versione", value: runtime.version },
    { id: "revision", label: "Revisione", value: build?.revision || "dev (non compilata)" },
    { id: "build", label: "Build", value: b.kind },
    { id: "commit", label: "Commit", value: b.commit },
    { id: "source-sha", label: "Source SHA256", value: build?.source_sha256 || "—" },
    { id: "build-date", label: "Data e ora build", value: build?.build_date || "—" },
    { id: "frontend-mode", label: "Modalità frontend", value: mode || "—" },
    { id: "served-by", label: "Frontend servito da", value: describeFrontendSource(runtime, client) },
    { id: "environment", label: "Ambiente", value: client.devServer ? "Development" : runtime.environment },
    { id: "foundation", label: "Foundation Version", value: runtime.foundation_version },
    { id: "shell", label: "Shell Version", value: runtime.shell_version || "n/d (standalone)" },
    { id: "python", label: "Python Runtime", value: `${runtime.python?.implementation} ${runtime.python?.version} · ${runtime.python?.os}` },
    { id: "node", label: "Node Runtime", value: build?.builder?.node ? `${build.builder.node} (build)` : "n/d" },
    { id: "database", label: "Database", value: `${db.engine} · ${db.location} (${db.source})` },
  ];
}

export function formatSystemInfoText(rows) {
  const width = Math.max(...rows.map((r) => r.label.length));
  const lines = rows.map((r) => `${r.label.padEnd(width)} : ${r.value ?? "—"}`);
  return ["Informazioni di sistema — Gruppo Impresa Suite", ...lines, `Generato il ${new Date().toISOString()}`].join("\n");
}
